import React, { useEffect, useState } from "react";
import { Container, ModalDialog } from "../../../components";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import PAGES from "../../../../../constants/pages";
import { RootState } from "../../../../../models";
import { isCheckout as isCheckoutSelector } from "../../../app/state/selectors";
import { isBankIdVerified as isBankIdVerifiedSelector } from "../../../authentication/state/selectors";
import BankIdSection from "../../../checkout/components/molecules/BankIdSectionTeliaBroker/BankIdSectionTeliaBroker";
import ContactCard from "../../../checkout/components/molecules/ContactCard/ContactCard";
import { resetOrder } from "../../../checkout/state/actions/phoneNumberActions";
import * as CUSTOMER_INFO_SELECTORS from "../../../checkout/state/selectors/customerInfoSelectors";
import { trackFunnelEvent } from "../../../google-analytics";
import PersonalDetailsForm from "../../components/organisms/PersonalDetailsForm/PersonalDetailsForm";
import { setCustomAddressChecked, saveContactInfo } from "../../state/actions";
import * as FWA_SELECTORS from "../../state/selectors";
import TEXT from "../../text-consts";
import { FWA_LABELS } from "../../../../../constants";
import "./Customer.less";

const Customer: React.FC = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const isSelectedPackageCabinDIY = useSelector((state: RootState) => FWA_SELECTORS.isSelectedPackageCabinDIY(state));
    const isBankIdVerified = useSelector((state: RootState) => isBankIdVerifiedSelector(state));
    const isCheckout = useSelector((state: RootState) => isCheckoutSelector(state));
    const legalOwnerFullName = useSelector((state: RootState) => CUSTOMER_INFO_SELECTORS.getLegalOwnerFullName(state));
    const legalOwnerBirthdate = useSelector((state: RootState) =>
        CUSTOMER_INFO_SELECTORS.getLegalOwnerBirthdate(state),
    );
    const [showLogOutBankIdModal, setShowLogoutBankIdModal] = useState(false);

    // Trigger GA funnel
    useEffect(() => {
        trackFunnelEvent({
            step: "2",
            label: `${FWA_LABELS[1]}${isSelectedPackageCabinDIY ? " Hytteeier" : ""}`,
            name: "FWA - Trådløst Bredbånd",
        });
        // oxlint-disable-next-line eslint-plugin-react-hooks/exhaustive-deps
    }, []);

    const handleToggleCustomAddress = (value: boolean) => {
        dispatch(setCustomAddressChecked(value));

        trackFunnelEvent({
            step: "2",
            label: FWA_LABELS[1],
            name: "FWA - Trådløst Bredbånd",
            isUIEvent: true,
            uiEventName: "Jeg vil ha antennen tilsendt hjem istedet for på hytta",
        });
    };

    return (
        <>
            {isBankIdVerified && (
                <ContactCard
                    headingText={TEXT.PERSONAL_DETAILS.HEADING_BANK_ID_VERIFIED}
                    name={legalOwnerFullName}
                    address={legalOwnerBirthdate}
                    resetBankId={(): void => setShowLogoutBankIdModal(true)}
                    showContactInfo={false}
                    showLogoutBankId={true}
                    isCheckout={isCheckout}
                />
            )}
            <Container className="fwa-personal-details" size="small" whiteBg>
                <BankIdSection referer="fwa" typeId="co_bankid" />
                {isBankIdVerified && (
                    <PersonalDetailsForm
                        onSubmitDetails={async () => {
                            await dispatch(saveContactInfo());
                            navigate(PAGES.FWA.PERSONAL_DETAILS.URL);
                        }}
                        setCustomAddressChecked={handleToggleCustomAddress}
                    />
                )}
            </Container>
            {showLogOutBankIdModal && (
                <ModalDialog
                    className="contact-card-container__logout-bankid"
                    size="small"
                    submitText="Ja, logg meg ut"
                    closeText="Nei, bli på siden"
                    closeKind="secondary"
                    heading="Ønsker du å logge ut av BankID?"
                    name="log-out-bank-id-modal"
                    onSubmit={(): void => {
                        dispatch(resetOrder());
                        setShowLogoutBankIdModal(false);
                    }}
                    onClose={() => setShowLogoutBankIdModal(false)}
                />
            )}
        </>
    );
};

export default Customer;
